import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Section from "../../common/Section";
import Fieldset from "../../common/Fieldset";
import Row from "../../common/Row";
import SporttakkenComponent from "./parts/SporttakkenComponent";
import Table from "../../common/Table";
import TextInput from "../../common/TextInput";
import Button from "../../common/Button";
import ConfirmModal from "../../common/ConfirmModal";

function getHeaders(level) {
    const headers = ["Sporttak", "Discipline", "Sub-discipline"];
    let tableHeaders = [];

    for (let i = 0; i <= level; i++) {
        if (i < 3) {
            tableHeaders.push(headers[i]);
        }
        else if (i === 3) {
            tableHeaders.splice(i - 1, 1);
            tableHeaders.push(headers[2] + ' ' + (i - 2).toString());
            tableHeaders.push(headers[2] + ' ' + (i - 1).toString());
        }
        else if (i > 3) {
            tableHeaders.push(headers[2] + ' ' + (i - 1).toString());
        }
    }

    return tableHeaders;
}

function getHeadersSizes(level) {
    let tableHeaderSizes = [];

    for (let i = 0; i <= level; i++) {
        tableHeaderSizes.push(100 / (level + 1));
    }

    return tableHeaderSizes;
}

const SporttakForm = (props) => {
    const {
        goToNext,
        goToPrev,
        model,
        searchresults,
        sporttakFilterHasFocus,
        onChange,
        onIncreaseLevel,
        onIncreaseSearchLevel,
        level,
        searchLevel,
        filter,
        onSearch,
        totalSearchResults,
        onChangeFilter,
        checkedSporttakken,
        unsavedCheckedSporttakken,
        onDelete,
        confrimDeleteSporttak,
        closeDeleteSporttakModal,
        showDeleteSporttakModal
    } = props;

    const sporttakkenForComponent = model.sporttakken.filter(m => m.moederId == '00000000-0000-0000-0000-000000000000');
    const searchresultsForComponent = searchresults.filter(m => m.moederId == '00000000-0000-0000-0000-000000000000');
    const disabledSporttakken = model.sporttakken.map(m => m.id);

    return (
        <Section>
            {showDeleteSporttakModal ? <ConfirmModal
                isOpen={showDeleteSporttakModal}
                title="Verwijder sportak(ken)"
                mainText="Weet je zeker dat je deze sportak(ken) wil verwijderen?"
                confirmAction={confrimDeleteSporttak}
                cancelAction={closeDeleteSporttakModal}
                confirmText="Ja"
                cancelText="Nee"
            /> : null}
            <Form
                name="sporttak"
                headerVisible={false}
                isNotRequired
                rightButtonLabel={searchresults.length > 0 ? "Bewaar" : "Ga verder"}
                leftButtonLabel={searchresults.length > 0 ? "Annuleer" : "Terug"}
                onRightButtonClick={goToNext}
                onLeftButtonClick={goToPrev}
            >
                <Fieldset>
                    <Row><div style={{ color: "#082b42", fontSize: "1.4375rem", fontWeight: "500", lineHeight: "28px", margin: "30px 0.83333% 0 0.83333%" }}>Sporttakken</div></Row>
                </Fieldset>
                <div style={{ width: "100%", height: "1px", backgroundColor: "#E6E6E6", marginTop: "30px" }}></div>
                <Fieldset>
                    {sporttakkenForComponent && sporttakkenForComponent.length > 0 ?
                        <Table
                            id="SporttakkenTable"
                            style={{ 'border': '1px', 'borderStyle': 'solid', 'borderColor': '#eeefef', 'frame': 'void', 'rules': 'rows' }}
                            headers={getHeaders(level)}
                            headerSizes={getHeadersSizes(level)}
                            setMinWidth
                        >
                            <SporttakkenComponent
                                sporttakken={sporttakkenForComponent}
                                onIncreaseLevel={onIncreaseLevel}
                                maxLevel={level}
                                hideCheckbox
                                checkedSporttakken={checkedSporttakken}
                                hasDeleteOption
                                onDelete={onDelete}
                                disableDelete={searchresults.length > 0}
                            />
                        </Table>
                        :
                        <p style={{ marginBottom: "20px" }}>Er werd nog geen sporttak toegevoegd.</p>
                    }
                    <TextInput
                        name="filter"
                        label="Sporttak"
                        value={filter}
                        onChange={onChangeFilter}
                        size={3}
                        onEnter={onSearch}
                        maxLength={50}
                        hasFocus={sporttakFilterHasFocus} />
                    <Button
                        onClick={onSearch}
                        text="Zoek"
                        selected
                        disabled={filter.length < 2}
                    />
                </Fieldset>
                <Fieldset>
                    <Row>
                        {(searchresults && searchresults.length) ?
                            <Table
                                style={{ 'border': '1px', 'borderStyle': 'solid', 'borderColor': '#eeefef', 'frame': 'void', 'rules': 'rows' }}
                                headers={getHeaders(searchLevel)}
                                headerSizes={getHeadersSizes(searchLevel)}
                                setMinWidth
                            >
                                <SporttakkenComponent
                                    sporttakken={searchresultsForComponent}
                                    checkedSporttakken={unsavedCheckedSporttakken.concat(...checkedSporttakken)}
                                    onChange={onChange}
                                    onIncreaseLevel={onIncreaseSearchLevel}
                                    disabledSporttakken={disabledSporttakken}
                                    maxLevel={searchLevel}
                                    disableChecked
                                    showAllSubsporttakken />
                            </Table>
                            :
                            totalSearchResults === -1 ||
                            <div>
                                <p style={{ margin: "15px 0" }}>Geen sporttakken gevonden die voldoen aan de opgegeven zoekcriteria.</p>
                            </div>
                        }
                    </Row>
                </Fieldset>
            </Form>
        </Section>
    );
};

SporttakForm.propTypes = {
    goToNext: PropTypes.func,
    goToPrev: PropTypes.func,
    model: PropTypes.object,
    searchresults: PropTypes.array,
    sporttakFilterHasFocus: PropTypes.bool,
    onChange: PropTypes.func,
    onIncreaseLevel: PropTypes.func,
    level: PropTypes.number,
    filter: PropTypes.string,
    onSearch: PropTypes.func,
    totalSearchResults: PropTypes.number,
    onChangeFilter: PropTypes.func,
    checkedSporttakken: PropTypes.array,
    searchLevel: PropTypes.number,
    onIncreaseSearchLevel: PropTypes.func,
    unsavedCheckedSporttakken: PropTypes.array,
    onDelete: PropTypes.func,
    confrimDeleteSporttak: PropTypes.func,
    closeDeleteSporttakModal: PropTypes.func,
    showDeleteSporttakModal: PropTypes.bool
};

export default SporttakForm;